import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { FiUploadCloud } from "react-icons/fi";
import { isAllowedFile } from "./fileKinds";

/**
 * Drop area for photo / RAW / video / audio files. Filtering is by extension because
 * browsers report an empty MIME type for most RAW formats.
 */
export default function TransferDropzone({ onFiles, disabled }) {
  const { t } = useTranslation();
  const [rejected, setRejected] = useState(0);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    disabled,
    multiple: true,
    onDrop: (files) => {
      const ok = files.filter(isAllowedFile);
      setRejected(files.length - ok.length);
      if (ok.length) onFiles(ok);
    },
  });

  return (
    <>
      <div {...getRootProps({ className: `shr-dropzone${isDragActive ? " active" : ""}` })}>
        <input {...getInputProps()} />
        <div className="shr-dropzone-icon"><FiUploadCloud size={22} /></div>
        <p className="shr-dropzone-title">
          {isDragActive ? t("share.dropzone.drop") : t("share.dropzone.title")}
        </p>
        <p className="shr-dropzone-hint">{t("share.dropzone.hint")}</p>
      </div>
      {rejected > 0 && (
        <p className="shr-muted" style={{ color: "#b91c1c", marginTop: 8 }}>
          {t("share.dropzone.rejected", { count: rejected })}
        </p>
      )}
    </>
  );
}
